module.exports = __webpack_public_path__ + "static/img/coins-3.a44654da.png";